// reactstrap components
import { BACKGROUND_COLOR } from "constants/Constant";
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";

const Footer = () => {
  return (
    <footer className="footer " style={{backgroundColor : BACKGROUND_COLOR}}>
      <Row className="align-items-center justify-content-between">
        <Col xl="12">
          <div className="copyright text-center text-xl-left text-muted">
            © {new Date().getFullYear()}{" "}
            <a
              className="font-weight-bold ml-1"
              href="#"
              // rel="noopener noreferrer"
              // target="_blank"
            >
              GoodyBuddy
            </a>
          </div>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
